module.exports = __webpack_public_path__ + "static/media/welcome-composition-with-flat-character_23-2147895814.849d6004.jpg";